"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XCHModule = void 0;
const leaflet_1 = require("./providers/leaflet");
const goby_1 = require("./providers/goby");
const multi_1 = require("./providers/multi");
const private_key_1 = require("./providers/private_key");
const network_1 = require("../util/network");
class XCHModule {
    static setProvider(p) {
        this.provider = p;
    }
    static createProvider({ leafletHost = "leaflet.fireacademy.io", leafletAPIKey, leafletPort = 18444, useGoby = false, gobyTryNonInteractiveConnect = true, network = network_1.Network.mainnet, privateKey, }) {
        const providers = [];
        if (useGoby) {
            providers.push(new goby_1.GobyProvider(gobyTryNonInteractiveConnect));
        }
        if (leafletAPIKey) {
            providers.push(new leaflet_1.LeafletProvider(leafletHost, leafletAPIKey, leafletPort, network));
        }
        if (privateKey) {
            providers.push(new private_key_1.PrivateKeyProvider(privateKey, network));
        }
        this.setProvider(new multi_1.MultiProvider(providers));
    }
    static clearProvider() {
        this.provider = null;
    }
    // Provider method wrappers
    static connect() {
        if (XCHModule.provider === null)
            throw new Error("Provider not set!");
        return XCHModule.provider.connect();
    }
    static close() {
        if (XCHModule.provider === null)
            throw new Error("Provider not set!");
        return XCHModule.provider.close();
    }
    static getNetworkId() {
        if (XCHModule.provider === null)
            throw new Error("Provider not set!");
        return XCHModule.provider.getNetworkId();
    }
    static isConnected() {
        if (XCHModule.provider === null)
            throw new Error("Provider not set!");
        return XCHModule.provider.isConnected();
    }
    static getBlockNumber() {
        if (XCHModule.provider === null)
            throw new Error("Provider not set!");
        return XCHModule.provider.getBlockNumber();
    }
    static getBalance(args) {
        if (XCHModule.provider === null)
            throw new Error("Provider not set!");
        return XCHModule.provider.getBalance(args);
    }
    static subscribeToPuzzleHashUpdates(args) {
        if (XCHModule.provider === null)
            throw new Error("Provider not set!");
        return XCHModule.provider.subscribeToPuzzleHashUpdates(args);
    }
    static subscribeToCoinUpdates(args) {
        if (XCHModule.provider === null)
            throw new Error("Provider not set!");
        return XCHModule.provider.subscribeToCoinUpdates(args);
    }
    static getPuzzleSolution(args) {
        if (XCHModule.provider === null)
            throw new Error("Provider not set!");
        return XCHModule.provider.getPuzzleSolution(args);
    }
    static getCoinChildren(args) {
        if (XCHModule.provider === null)
            throw new Error("Provider not set!");
        return XCHModule.provider.getCoinChildren(args);
    }
    static getBlockHeader(args) {
        if (XCHModule.provider === null)
            throw new Error("Provider not set!");
        return XCHModule.provider.getBlockHeader(args);
    }
    static getBlocksHeaders(args) {
        if (XCHModule.provider === null)
            throw new Error("Provider not set!");
        return XCHModule.provider.getBlocksHeaders(args);
    }
    static getCoinRemovals(args) {
        if (XCHModule.provider === null)
            throw new Error("Provider not set!");
        return XCHModule.provider.getCoinRemovals(args);
    }
    static getCoinAdditions(args) {
        if (XCHModule.provider === null)
            throw new Error("Provider not set!");
        return XCHModule.provider.getCoinAdditions(args);
    }
    static pushSpendBundle(args) {
        if (XCHModule.provider === null)
            throw new Error("Provider not set!");
        return XCHModule.provider.pushSpendBundle(args);
    }
    static getAddress() {
        if (XCHModule.provider === null)
            throw new Error("Provider not set!");
        return XCHModule.provider.getAddress();
    }
    static transfer(args) {
        if (XCHModule.provider === null)
            throw new Error("Provider not set!");
        return XCHModule.provider.transfer(args);
    }
    static transferCAT(args) {
        if (XCHModule.provider === null)
            throw new Error("Provider not set!");
        return XCHModule.provider.transferCAT(args);
    }
    static acceptOffer(args) {
        if (XCHModule.provider === null)
            throw new Error("Provider not set!");
        return XCHModule.provider.acceptOffer(args);
    }
    static subscribeToAddressChanges(args) {
        if (XCHModule.provider === null)
            throw new Error("Provider not set!");
        return XCHModule.provider.subscribeToAddressChanges(args);
    }
    static signCoinSpends(args) {
        if (XCHModule.provider === null)
            throw new Error("Provider not set!");
        return XCHModule.provider.signCoinSpends(args);
    }
    static changeNetwork(args) {
        if (XCHModule.provider === null)
            throw new Error("Provider not set!");
        return XCHModule.provider.changeNetwork(args);
    }
}
exports.XCHModule = XCHModule;
XCHModule.providers = {
    LeafletProvider: leaflet_1.LeafletProvider,
    GobyProvider: goby_1.GobyProvider,
    MultiProvider: multi_1.MultiProvider,
    PrivateKeyProvider: private_key_1.PrivateKeyProvider
};
XCHModule.provider = null;
//# sourceMappingURL=index.js.map